export default "__VITE_ASSET__ffeef0b7__"